(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["URLSearchUtils"] = factory();
	else
		root["URLSearchUtils"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = parseQuery;
function parseQuery(search) {
  var paramsTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (search.length === 0) {
    return {};
  }

  return search.split('&').reduce(function (result, searchItem) {
    var _searchItem$split = searchItem.split('='),
        _searchItem$split2 = _slicedToArray(_searchItem$split, 2),
        name = _searchItem$split2[0],
        rawValue = _searchItem$split2[1];

    var value = decodeURIComponent(rawValue);

    if (paramsTypes[name]) {
      if (typeof paramsTypes[name] === 'function') {
        result[name] = paramsTypes[name](value, result[name]);

        return result;
      }

      switch (paramsTypes[name]) {
        case 'array-of-strings':
          if (!result[name]) {
            result[name] = [];
          }

          result[name].push(value);

          return result;

        case 'array-of-numbers':
          if (!result[name]) {
            result[name] = [];
          }

          result[name].push(parseFloat(value));

          return result;

        case 'number':
          result[name] = parseFloat(value);

          return result;

        case 'exclude':

          return result;

        default:
          throw new Error('Unknown type of parameter for parse "' + name + '": "' + paramsTypes[name] + '"');
      }
    }

    result[name] = value;

    return result;
  }, {});
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stringifyParams;
function stringifyParams(params) {
  var mapParamsNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var paramsTypes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return Object.keys(params).map(function (rawParamName) {
    var paramName = mapParamsNames[rawParamName] || rawParamName;
    var paramValue = params[rawParamName];

    if (paramsTypes[paramName]) {
      if (typeof paramsTypes[paramName] === 'function') {
        var mappedParamValue = paramsTypes[paramName](paramValue);

        if (mappedParamValue === null || typeof mappedParamValue === 'undefined') {
          return null;
        }

        return paramName + '=' + encodeURIComponent(mappedParamValue);
      }

      switch (paramsTypes[paramName]) {
        case 'exclude':
          return null;

        case 'include-if-falsy':
          return paramName + '=' + encodeURIComponent(paramValue || '');

        default:
          throw new Error('Unknown type of parameter for serialize "' + paramName + '": "' + paramsTypes[paramName] + '"');
      }
    }

    if (paramValue instanceof Array) {
      if (paramValue.length === 0) {
        return null;
      }

      return paramValue.map(function (paramValueItem) {
        return paramName + '=' + encodeURIComponent(paramValueItem);
      }).join('&');
    }

    if (!paramValue) {
      return null;
    }

    return paramName + '=' + encodeURIComponent(paramValue);
  }).filter(function (item) {
    return item !== null;
  }).join('&');
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseHashLocationQuery;

var _parseQuery = __webpack_require__(0);

var _parseQuery2 = _interopRequireDefault(_parseQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseHashLocationQuery() {
  var paramsTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var search = window.location.hash.split('?')[1] || '';

  return (0, _parseQuery2.default)(search, paramsTypes);
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseHashParams;

var _parseQuery = __webpack_require__(0);

var _parseQuery2 = _interopRequireDefault(_parseQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseHashParams() {
  var paramsTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var search = window.location.hash.replace(/^#/, '');

  return (0, _parseQuery2.default)(search, paramsTypes);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseSearchParams;

var _parseQuery = __webpack_require__(0);

var _parseQuery2 = _interopRequireDefault(_parseQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseSearchParams() {
  var paramsTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var search = window.location.search;

  return (0, _parseQuery2.default)(search.substring(1, search.length), paramsTypes);
}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setHashLocationQuery;

var _stringifyParams = __webpack_require__(1);

var _stringifyParams2 = _interopRequireDefault(_stringifyParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setHashLocationQuery(params, mapParamsNames, paramsTypes) {
  var paramsStr = (0, _stringifyParams2.default)(params, mapParamsNames, paramsTypes);

  var hashWithoutSearch = window.location.hash.replace(/^#/, '').split('?')[0];

  window.history.replaceState(null, null, '#' + hashWithoutSearch + '?' + paramsStr);
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setHashParams;

var _stringifyParams = __webpack_require__(1);

var _stringifyParams2 = _interopRequireDefault(_stringifyParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setHashParams(params, mapParamsNames, paramsTypes) {
  var paramsStr = (0, _stringifyParams2.default)(params, mapParamsNames, paramsTypes);

  window.history.replaceState(null, null, '#' + paramsStr);
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setSearchParams;

var _stringifyParams = __webpack_require__(1);

var _stringifyParams2 = _interopRequireDefault(_stringifyParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setSearchParams(params, mapParamsNames, paramsTypes) {
  var paramsStr = (0, _stringifyParams2.default)(params, mapParamsNames, paramsTypes);

  window.history.replaceState({}, null, window.location.pathname + '?' + paramsStr);
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parseQuery = __webpack_require__(0);

Object.defineProperty(exports, 'parseQuery', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parseQuery).default;
  }
});

var _stringifyParams = __webpack_require__(1);

Object.defineProperty(exports, 'stringifyParams', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stringifyParams).default;
  }
});

var _parseSearchParams = __webpack_require__(4);

Object.defineProperty(exports, 'parseSearchParams', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parseSearchParams).default;
  }
});

var _parseHashParams = __webpack_require__(3);

Object.defineProperty(exports, 'parseHashParams', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parseHashParams).default;
  }
});

var _parseHashLocationQuery = __webpack_require__(2);

Object.defineProperty(exports, 'parseHashLocationQuery', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parseHashLocationQuery).default;
  }
});

var _setSearchParams = __webpack_require__(7);

Object.defineProperty(exports, 'setSearchParams', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_setSearchParams).default;
  }
});

var _setHashParams = __webpack_require__(6);

Object.defineProperty(exports, 'setHashParams', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_setHashParams).default;
  }
});

var _setHashLocationQuery = __webpack_require__(5);

Object.defineProperty(exports, 'setHashLocationQuery', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_setHashLocationQuery).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ })
/******/ ]);
});